var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toolbar-button',{attrs:{"icon":"mdi-folder-plus-outline","tooltip":"Create a new folder"},on:{"click":_vm.createFolderModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }